// Cookie consent: stored on the device only after the visitor chooses. No tags load until they opt in.
const KEY = "ccpc-consent";
const OLD_KEY = "ccpc-analytics-consent";
const MAX_AGE = 365 * 864e5;
export const CONSENT_EVENT = "ccpc-consent-change";
export const OPEN_SETTINGS_EVENT = "ccpc-open-cookie-settings";

// Booking, intake, contact, account and admin pages never load analytics or advertising tags.
const NO_TAG_PREFIXES = ["/enquiry", "/follow-up", "/complete-payment", "/payment", "/pay/", "/contact", "/referrals",
  "/login", "/register", "/forgot-password", "/reset-password", "/mfa-setup", "/dashboard", "/admin", "/manage-booking"];
export const isNoTagPage = (path) => NO_TAG_PREFIXES.some((p) => path.startsWith(p));

export function readConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    if (c && Date.now() - c.at < MAX_AGE) return c;
    const old = localStorage.getItem(OLD_KEY);
    if (old) return { analytics: old === "granted", ads: old === "granted", at: Date.now() };
  } catch { /* storage unavailable */ }
  return null;
}

export function saveConsent({ analytics, ads }) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ analytics: !!analytics, ads: !!ads, at: Date.now() }));
    localStorage.removeItem(OLD_KEY);
  } catch { /* storage unavailable */ }
  window.dispatchEvent(new Event(CONSENT_EVENT));
}

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
